<template>
<v-fade-transition mode="in-out">
  <router-view/>
</v-fade-transition>
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: 'FPT AI for developers',
    htmlAttrs: { lang: 'en' },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },
  data: () => ({
    //
  }),
};
</script>
<style>
html::-webkit-scrollbar{
  display: none;
}
html {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
</style>
